import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief  brief_novelcraft p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2>
              Client <span style={{ color: "#EA6098" }}>Brief</span>
            </h2>
            <p>
              Inspired by the New York Times Best Seller, “Beautiful Disaster,”
              NovelCraft allows players to step in the shoes of favorite
              characters, and take control of their fates. With over 21 episodes
              to unlock, your choices will determine how the game ends.
            </p>
            <h2>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#EA6098" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#EA6098" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#EA6098" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
